// extracted by css-extract-rspack-plugin
export default {"container":"src-wab-commons-components-inputs-BetterAutoComplete-module__container-GAWQ5Y","item__active":"src-wab-commons-components-inputs-BetterAutoComplete-module__item__active-dxdSOR","itemActive":"src-wab-commons-components-inputs-BetterAutoComplete-module__item__active-dxdSOR"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"src-wab-commons-components-inputs-BetterAutoComplete-module__container-GAWQ5Y\",\"item__active\":\"src-wab-commons-components-inputs-BetterAutoComplete-module__item__active-dxdSOR\",\"itemActive\":\"src-wab-commons-components-inputs-BetterAutoComplete-module__item__active-dxdSOR\"}";
        // 1793541997519
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  